import React from 'react'
import { useSelector } from 'react-redux'
import { Toast } from '@chilecompra/react-kit'
import { useAuthorization } from '../AuthorizationProvider/AuthorizationProvider.hooks'
import { Root, Grid } from './QuoteNotification.styles'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'

/*
 * The QuoteNotification' container.
 */
const QuoteNotification = () => {
  const { cancellationDays, showDisclaimer } = useSelector(state => state.quoteSearchHeadingFilters)
  const { isBuyer } = useAuthorization()

  return (
    <Root>
      {isBuyer && (
        <ProtectByFeatures rule={features => features['cases.tcp']}>
          {showDisclaimer && (
            <Grid container margin="32px 0" width="100%">
              <Toast width="100%" severity="warning" title="Nueva cancelación automática de procesos en Compra Ágil.">
                <br /> Te informamos que el módulo de Compra Ágil ahora cuenta con una nueva funcionalidad que cancelará
                automáticamente todos los procesos que hayan recibido cotizaciones y que no tengan una oferta
                seleccionada en un plazo de {cancellationDays} días corridos.
              </Toast>
            </Grid>
          )}
        </ProtectByFeatures>
      )}
    </Root>
  )
}

export default QuoteNotification
